module.exports = __webpack_public_path__ + "img/02-avatar male.c9c00d40.png";